export default {
  error: false,
  errorMessage: '',
  charging: false,
}
